"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withBreakpoints = void 0;
var _react = _interopRequireDefault(require("react"));
var _useBreakpoints = require("../useBreakpoints");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// HOC
var withBreakpoints = function withBreakpoints(TargetComponent) {
  return function (props) {
    var breakpoints = (0, _useBreakpoints.useBreakpoints)(); // TypeScript error with React.ComponentType means it won't allow
    // it to be returned in a rendered format. Need to recast it to
    // a FunctionalComponent to allow the generic T to be passed in

    var RecastComponent = TargetComponent;
    return /*#__PURE__*/_react["default"].createElement(RecastComponent, _extends({}, props, {
      breakpoints: breakpoints
    }));
  };
};
exports.withBreakpoints = withBreakpoints;